module.exports = __webpack_public_path__ + "img/img53.16865b9b.svg";